/**
 * Quick View Size Selection Validation - MATCHES PDP BEHAVIOR
 * Works with quickbuy-canvas drawer on PLP
 * Uses native Shopify cart functionality like PDP
 */

(function() {
  'use strict';
  
  console.log('👁️ Quick View size validation - PDP BEHAVIOR loaded');
  
  // Track current product ID
  let currentProductId = null;
  
  // Get product ID from Quick View
  function getProductId(container) {
    const productJson = container.querySelector('script[data-product-json]');
    if (productJson) {
      try {
        const product = JSON.parse(productJson.textContent);
        return product.id;
      } catch(e) {
        console.log('Could not parse product JSON');
      }
    }
    return null;
  }
  
  // Initialize validation for Quick View
  function initQuickViewValidation(container) {
    console.log('🔧 Initializing Quick View validation');
    
    setTimeout(() => {
      const productId = getProductId(container);
      
      if (productId && productId === currentProductId) {
        console.log('ℹ️ Same product, skipping');
        return;
      }
      
      currentProductId = productId;
      console.log('🆕 New product:', productId);
      
      // Find size options
      const sizeInputs = container.querySelectorAll('input[name="Size"]');
      const sizeSelects = container.querySelectorAll('select[name*="Size"]');
      
      if (sizeInputs.length === 0 && sizeSelects.length === 0) {
        console.log('ℹ️ No size options');
        return;
      }
      
      console.log('✅ Found size options:', {
        radios: sizeInputs.length,
        selects: sizeSelects.length
      });
      
      // Find the form
      const forms = container.querySelectorAll('form[data-type="add-to-cart-form"], form.quick-buy-form, form[action*="cart/add"]');
      
      if (forms.length === 0) {
        console.log('⚠️ Form not found');
        return;
      }
      
      // Clone forms to remove old listeners
      forms.forEach((form, formIndex) => {
        const newForm = form.cloneNode(true);
        form.parentNode.replaceChild(newForm, form);
        console.log(`🔄 Reset form ${formIndex}`);
      });
      
      // Get fresh form references
      const freshForms = container.querySelectorAll('form[data-type="add-to-cart-form"], form.quick-buy-form, form[action*="cart/add"]');
      
      freshForms.forEach((form, formIndex) => {
        console.log(`📝 Setting up form ${formIndex}`);
        
        // CRITICAL: Intercept form submit and add to cart via AJAX
        form.addEventListener('submit', function(e) {
          console.log(`📝 Form ${formIndex} submit detected`);
          
          // Always prevent default form submission (which goes to cart page)
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Validate size selection
          if (!validateQuickViewSize(container)) {
            console.log('❌ BLOCKING - no size selected');
            showQuickViewAlert(container);
            return false;
          }
          
          console.log('✅ Size selected - adding to cart via AJAX');
          
          // Get form data
          const formData = new FormData(form);
          
          // Add to cart using Shopify's cart/add endpoint
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: formData.get('id'),
                quantity: parseInt(formData.get('quantity')) || 1
              }]
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('✅ Added to cart successfully:', data);
            
            // Trigger cart drawer to open and refresh
            openCartDrawer();
            
            // Close Quick View after 1 second
            setTimeout(() => {
              const quickView = container.closest('quickbuy-canvas, .quick_shop-popup');
              if (quickView) {
                quickView.classList.remove('active');
              }
            }, 1000);
          })
          .catch(error => {
            console.error('❌ Error adding to cart:', error);
            alert('Sorry, there was an error adding this item to your cart.');
          });
          
          return false;
        }, true);
        
        // Also handle button clicks
        const submitBtns = form.querySelectorAll('button[type="submit"], .product-form__submit, .product_submit_button');
        submitBtns.forEach((submitBtn, btnIndex) => {
          if (submitBtn) {
            const newBtn = submitBtn.cloneNode(true);
            submitBtn.parentNode.replaceChild(newBtn, submitBtn);
            
            newBtn.addEventListener('click', function(e) {
              console.log(`🔘 Button ${btnIndex} clicked`);
              
              // Prevent default to stop cart page navigation
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              
              if (!validateQuickViewSize(container)) {
                console.log('❌ BLOCKING button - no size selected');
                showQuickViewAlert(container);
                return false;
              }
              
              console.log('✅ Size selected - triggering form submit');
              // Trigger form submit which will handle AJAX
              form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
              
              return false;
            }, true);
          }
        });
      });
      
      console.log('✅ Quick View validation initialized for product:', productId);
    }, 200);
  }
  
  // Validate size selection
  function validateQuickViewSize(container) {
    const sizeInputs = container.querySelectorAll('input[name="Size"]:not(.disabled)');
    const sizeSelects = container.querySelectorAll('select[name*="Size"]');
    
    let sizeSelected = false;
    
    // Check radios
    sizeInputs.forEach(input => {
      if (input.checked && !input.disabled && input.offsetParent !== null) {
        sizeSelected = true;
        console.log('✅ Size selected (radio):', input.value);
      }
    });
    
    // Check selects
    sizeSelects.forEach(select => {
      if (select.value && select.value !== '' && select.value !== 'Please select a size' && select.offsetParent !== null) {
        sizeSelected = true;
        console.log('✅ Size selected (select):', select.value);
      }
    });
    
    return sizeSelected;
  }
  
  // Show alert
  function showQuickViewAlert(container) {
    const existing = container.querySelector('.qv-size-alert');
    if (existing) existing.remove();
    
    const alert = document.createElement('div');
    alert.className = 'qv-size-alert';
    alert.style.cssText = `
      position: sticky;
      top: 0;
      z-index: 999;
      background: #FFFFFF;
      border: 2px solid #F9F6F0;
      border-radius: 8px;
      padding: 12px 20px;
      margin-bottom: 15px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      display: flex;
      align-items: center;
      gap: 10px;
      color: #610F23;
      font-size: 14px;
      font-weight: 600;
      animation: slideDown 0.3s ease;
    `;
    
    alert.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
        <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z"/>
      </svg>
      <span>👉 Please select a size before proceeding.</span>
    `;
    
    if (!document.querySelector('#qv-alert-animation')) {
      const style = document.createElement('style');
      style.id = 'qv-alert-animation';
      style.textContent = `
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `;
      document.head.appendChild(style);
    }
    
    const scrollableContent = container.querySelector('.popup-quick-view__body, .quickview-content');
    if (scrollableContent) {
      scrollableContent.insertBefore(alert, scrollableContent.firstChild);
      scrollableContent.scrollTop = 0;
    } else {
      container.insertBefore(alert, container.firstChild);
    }
    
    setTimeout(() => {
      const sizeField = container.querySelector(
        'fieldset.product-form__input_size, ' +
        '.product-form__input_size, ' +
        'input[name="Size"]'
      );
      if (sizeField) {
        const fieldContainer = sizeField.closest('fieldset, .quickbuy-block, .product-form__input');
        if (fieldContainer) {
          fieldContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }, 100);
    
    setTimeout(() => {
      alert.style.opacity = '0';
      alert.style.transition = 'opacity 0.3s';
      setTimeout(() => alert.remove(), 300);
    }, 4000);
  }
  
  // Watch for Quick View to open
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.classList && (
            node.classList.contains('quick_shop-popup') ||
            node.classList.contains('quickbuy-canvas') ||
            node.tagName === 'QUICKBUY-CANVAS'
          )) {
            console.log('✅ Quick View opened');
            initQuickViewValidation(node);
          }
          
          const quickviewContent = node.querySelector('.quickview-content, .quick_shop-popup, quickbuy-canvas');
          if (quickviewContent) {
            console.log('✅ Quick View content detected');
            const canvas = quickviewContent.closest('quickbuy-canvas, .quick_shop-popup') || node;
            initQuickViewValidation(canvas);
          }
        }
      });
      
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList && (
          target.classList.contains('quick_shop-popup') ||
          target.classList.contains('quickbuy-canvas') ||
          target.tagName === 'QUICKBUY-CANVAS'
        )) {
          if (target.classList.contains('active')) {
            console.log('✅ Quick View activated');
            initQuickViewValidation(target);
          }
        }
      }
      
      if (mutation.type === 'childList') {
        const target = mutation.target;
        const quickView = target.closest('quickbuy-canvas, .quick_shop-popup');
        if (quickView && quickView.classList.contains('active')) {
          const hasProductJson = Array.from(mutation.addedNodes).some(node => 
            node.nodeType === 1 && node.querySelector && node.querySelector('script[data-product-json]')
          );
          if (hasProductJson) {
            console.log('🔄 Product changed');
            currentProductId = null;
            initQuickViewValidation(quickView);
          }
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
  
  document.addEventListener('DOMContentLoaded', function() {
    console.log('📍 DOM Ready');
    const existingQuickView = document.querySelector('.quick_shop-popup, quickbuy-canvas, [class*="quick"]');
    if (existingQuickView && existingQuickView.classList.contains('active')) {
      console.log('✅ Quick View already open');
      initQuickViewValidation(existingQuickView);
    }
  });
  
  document.addEventListener('click', function(e) {
    const quickViewBtn = e.target.closest('button-quickview, .quickview-button, [class*="quickview"], [class*="quick-view"], [data-quickview]');
    if (quickViewBtn) {
      console.log('👁️ Quick View button clicked');
      currentProductId = null;
      
      const checkIntervals = [100, 300, 500, 800, 1200];
      checkIntervals.forEach(delay => {
        setTimeout(() => {
          const quickView = document.querySelector('.quick_shop-popup.active, quickbuy-canvas.active, .quick_shop-popup, quickbuy-canvas');
          if (quickView) {
            console.log(`✅ Quick View found after ${delay}ms`);
            initQuickViewValidation(quickView);
          }
        }, delay);
      });
    }
  }, true);
  
  setInterval(function() {
    const activeQuickView = document.querySelector('quickbuy-canvas.active, .quick_shop-popup.active');
    if (activeQuickView) {
      const productId = getProductId(activeQuickView);
      if (productId && productId !== currentProductId) {
        console.log('✅ Quick View found via interval');
        initQuickViewValidation(activeQuickView);
      }
    }
  }, 500);
  
  // Open cart drawer using your theme's native method
  function openCartDrawer() {
    console.log('🛒 Opening cart drawer');
    
    // Method 1: Use your theme's CartDrawer renderContents method
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        console.log('✅ Cart data fetched:', cart);
        
        // Update cart count in header
        document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.style.display = '';
            el.classList.remove('hidden');
          }
        });
        
        // Method 2: Fetch cart drawer section and update
        return fetch('/?sections=cart-drawer,cart-icon-bubble')
          .then(response => response.json())
          .then(sections => {
            console.log('✅ Cart sections fetched');
            
            // Update cart drawer content
            const cartDrawerElement = document.querySelector('cart-drawer');
            if (cartDrawerElement) {
              const parser = new DOMParser();
              const html = parser.parseFromString(sections['cart-drawer'], 'text/html');
              const newCartDrawer = html.querySelector('#CartDrawer');
              
              if (newCartDrawer) {
                const currentCartDrawer = document.querySelector('#CartDrawer');
                if (currentCartDrawer) {
                  currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
                  console.log('✅ Cart drawer content updated');
                }
              }
              
              // Now open the cart drawer using your theme's method
              setTimeout(() => {
                if (typeof cartDrawerElement.open === 'function') {
                  cartDrawerElement.open();
                  console.log('✅ Cart drawer opened via open() method');
                } else {
                  // Fallback: trigger click on cart icon
                  const cartIcon = document.querySelector('#cart-icon-bubble, .icon--cart-action');
                  if (cartIcon) {
                    cartIcon.click();
                    console.log('✅ Cart drawer opened via cart icon click');
                  } else {
                    // Last resort: add active class
                    cartDrawerElement.classList.add('active');
                    document.documentElement.classList.add('open-canvas');
                    console.log('✅ Cart drawer opened via class manipulation');
                  }
                }
              }, 100);
            }
          });
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }
  
  console.log('✅ Quick View validation ready - uses AJAX cart + native drawer');
})();